import React, { forwardRef, useImperativeHandle, useState } from 'react';

import Modal, { ModalProps } from '../Modal';

export interface ActionModalComponentProps {
  ref?: React.RefAttributes<HTMLElement>;
  onLoadingChanged?: (loading: boolean) => void;
  onFinish?: () => void;
}

interface ActionModalProps extends Omit<ModalProps, 'open' | 'onClose' | 'children'> {
  Component: React.ComponentType<ActionModalComponentProps & any>;
  componentProps?: any;
}

const ActionModal = forwardRef(({ Component, componentProps, ...rest }: ActionModalProps, ref) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const componentRef = React.useRef(null);

  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
    close: () => {
      setOpen(false);
    },
  }));

  return (
    <Modal
      open={isOpen}
      loading={loading}
      onClose={() => setOpen(false)}
      onSubmit={() => componentRef.current.submit()}
      {...rest}
    >
      <Component ref={componentRef} onLoadingChanged={setLoading} onFinish={() => setOpen(false)} {...componentProps} />
    </Modal>
  );
});

export default ActionModal;
